export enum RedirectType {
  USER_GROUPS = 'user_groups',
  MEMBERS_AREA = 'members_area',
  EXTERNAL_URL = 'external_url',
  UPSELL = 'upsell',
}
